var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filter-area"},[(_vm.title)?_c('div',{staticClass:"filter-title"},[_c('h4',[_vm._v(_vm._s(this.title))])]):_vm._e(),_c('div',{staticClass:"filter-body"},[_vm._t("inside-filter-body")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }